import { useQuery } from "react-query";
import { getAllTimetables, getTimetableDetail, } from "frontend/src/api/timetables";
import { cacheKey } from "./shared";
export var useTimetable = function (id) {
    return useQuery([cacheKey, id], function () { return getTimetableDetail(id); });
};
export var useTimetables = function () {
    return useQuery([cacheKey], getAllTimetables);
};
